import { render, staticRenderFns } from "./DomainInfo.vue?vue&type=template&id=94385d54&scoped=true"
import script from "./DomainInfo.vue?vue&type=script&lang=js"
export * from "./DomainInfo.vue?vue&type=script&lang=js"
import style0 from "./DomainInfo.vue?vue&type=style&index=0&id=94385d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94385d54",
  null
  
)

export default component.exports